import {ListItem} from "../../../common/types";

export const getListOptions = (dropdownValues: ListItem[]): {value: string, uiLabel: string}[] => {
    return dropdownValues.filter((field: ListItem) => !field.inactive).map((item: ListItem) => ({value: item.code, uiLabel: item.label})) || [];
};
